function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (function (theme, _ref) {
  var getColor = _ref.getColor,
      getTextStyle = _ref.getTextStyle;
  return {
    getCSS: function getCSS(_ref2) {
      var targetElement = _ref2.targetElement,
          color = _ref2.color,
          isChecked = _ref2.isChecked;

      switch (targetElement) {
        case "radio":
          {
            return {
              display: "flex",
              flexDirection: "column",
              height: "100%"
            };
          }

        case "radioInput":
          {
            return _objectSpread(_objectSpread({}, theme.focusStyles.focusVisibleAdjacentLabel), {}, {
              ":checked + label": {
                backgroundColor: theme.colors.secondary.lightBlue.t25,
                color: theme.colors.primary.blue.t100
              }
            });
          }

        case "radioLabel":
          {
            return _objectSpread(_objectSpread({
              display: "inline-flex",
              alignItems: "flex-start",
              padding: "".concat(theme.space[3], " ").concat(theme.space[4]),
              minHeight: "24px",
              height: "100%"
            }, getTextStyle({
              name: "body1",
              mode: "container"
            })), {}, {
              color: theme.colors.black,
              backgroundColor: getColor(color),
              borderRadius: theme.radii[0]
            });
          }

        case "circleSvg":
          {
            return {
              flexShrink: 0,
              width: "24px",
              height: "24px",
              marginRight: theme.space[3]
            };
          }

        case "outerCircle":
          {
            return {
              fill: getColor(color === "grey.t05" || isChecked ? "white" : "secondary.lightBlue.t25")
            };
          }

        case "innerCircle":
          {
            return {
              fill: theme.colors.primary.blue.t100
            };
          }

        case "description":
          {
            return {
              marginTop: theme.space[1]
            };
          }

        default:
          {
            return null;
          }
      }
    }
  };
});